module.exports = __webpack_public_path__ + "static/media/month_04.70b9b58b.png";